module.exports = __webpack_public_path__ + "img/fort-awesome-alt.0b308c25.svg";